/**
 * @generated SignedSource<<04b4fe1fd9f0cdc74431c2bc8485bdcc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PromoCodeDialogActivePromocodeMutation$variables = {
  affiliateName: string;
};
export type PromoCodeDialogActivePromocodeMutation$data = {
  readonly activatePromocode: {
    readonly installReferrer: string | null;
  };
};
export type PromoCodeDialogActivePromocodeMutation = {
  response: PromoCodeDialogActivePromocodeMutation$data;
  variables: PromoCodeDialogActivePromocodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "affiliateName"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "affiliateName",
    "variableName": "affiliateName"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "installReferrer",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PromoCodeDialogActivePromocodeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "activatePromocode",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PromoCodeDialogActivePromocodeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "activatePromocode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9c74ae049b874993142c401b1ad7e36a",
    "id": null,
    "metadata": {},
    "name": "PromoCodeDialogActivePromocodeMutation",
    "operationKind": "mutation",
    "text": "mutation PromoCodeDialogActivePromocodeMutation(\n  $affiliateName: String!\n) {\n  activatePromocode(affiliateName: $affiliateName) {\n    installReferrer\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "827d6c6c602ad5c4fc353ce71cd1fa68";

export default node;
